// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { TypesaurusCoreDoc } from '@res/ngg-core';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { InvoiceDef, InvoiceRef, InvoiceUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace InvoiceActions {
  export class GetAllInvoices {
    static readonly type = '[Invoice] GetAllInvoice';
    readonly type = GetAllInvoices.type;
  }

  export class InitInvoiceCount {
    static readonly type = '[Invoice] InitInvoicesCount';
    readonly type = InitInvoiceCount.type;
  }

  export class InitInvoice {
    static readonly type = '[Invoice] InitInvoices';
    readonly type = InitInvoice.type;
  }
  export class CountInvoices {
    static readonly type = '[Invoice] CountInvoices';
    readonly type = CountInvoices.type;
  }

  export class CloseInvoicesConnection {
    static readonly type = '[Invoice] CloseInvoicesConnection';
    readonly type = CloseInvoicesConnection.type;
  }

  export class GetInvoiceById {
    static readonly type = '[Invoice] GetInvoiceById';
    readonly type = GetInvoiceById.type;
  }

  export class UpdateInvoice {
    static readonly type = '[Invoice] UpdateInvoice';
    constructor(
      public invoiceData: Partial<InvoiceUpdateData>,
      public ref: InvoiceRef,
    ) {}
  }

  export class DeleteInvoices {
    static readonly type = '[Invoice] DeleteInvoices';
    constructor(public refs: InvoiceRef[]) {}
  }

  export class PaginateQueryInvoice {
    static readonly type = '[Invoice] PaginateQueryInvoice';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public invoiceId?: string,
    ) {}
  }
  export class InvoiceError {
    static readonly type = '[Invoice] InvoiceError';
    constructor(public error: Error) {}
  }

  export class GetSumOf {
    static readonly type = '[Invoice] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Invoice] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public invoiceId?: string,
    ) {}
  }

  export class UpdateInvoiceResult {
    static readonly type = '[Invoice] UpdateInvoiceResult';
    constructor(public data: Array<TypesaurusCoreDoc<InvoiceDef> | null | undefined>) {}
  }
}
